export default __webpack_public_path__ + "static/media/bronze.25fa6114.svg";